import React, { useEffect, useState } from 'react';

/**
 * PC_Gc_04 getEmpGoalData gets imported from api.js file
 */
import { getEmpGoalData } from '../service/api';
import '../components/css/Dashboard-styles.css';

const EmployeeGoalData = () => {

        /**
 * PC_MTc_02
 * The data  state variable is created for storing the response data
 */

    const [data, setData] = useState([]);


/**
  * PC_Gc_03
  * Use Efffect method is called 
  */

    useEffect(() => {
        fetchApi();
    });

        /**
 * PC_Gc_06
 * The fetchApi function in the useEffects gets invoked which inturn call the getEmpGoalData() function with respective parameters
 */

    const fetchApi = async () => {
        const resp = await getEmpGoalData();

        if (resp?.data?.ResponseData?.length > 0) {
            setData(resp.data.ResponseData);
        }
    };


            /**
 * PC_Gc_10
 * The response data gets stored in the data variable and mapped to the respective divs
 */

    const empGoalBody = () => {
        try {
            return data.map((datum, i) => {
                return (
                    <h2 href="#" className="bold-text font-12 ms-4 mt-3 d-block">
                        <span>
                            <img src="/Images/Performance (2).png" className="dashboard-goal-image-size me-3" />
                        </span>
                        {datum}
                    </h2>
                );
            });
        } catch (err) {}
    };

    return (
        <>
            <div className="d-flex justify-content-between">
                <h1 className="tt-bold font-15 pt-3 ps-3">My Goals</h1>
                {/* <a href="#" className="semibold-text font-12 pe-3 text-decoration-none mt-3">View all<span><img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" /></span></a>
                 */}
            </div>

            {empGoalBody()}
        </>
    );
};

export default EmployeeGoalData;
